import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CountForm } from "@/components/warehouse/CountForm";
import { TechKit } from "@/pages/tech/TechKit";

export default function TechInventory() {
  const [counts, setCounts] = useState(null);
  const load = useCallback(() => api.get("/tech/counts").then((r) => setCounts(r.data)).catch(() => setCounts([])), []);
  useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="tech-inventory-page">
      <h1 className="font-display text-3xl font-extrabold">Il mio furgone</h1>
      <p className="mt-1 text-sm text-muted-foreground">Materiali, apparati e attrezzature presenti nel furgone o assegnati a te.</p>
      <TechKit />
      <h2 className="mt-10 font-display text-xl font-extrabold">Inventario furgone</h2>
      <p className="mt-1 text-sm text-muted-foreground">Conta il materiale presente nel furgone quando l'ufficio apre un inventario. Serve la connessione per salvare.</p>
      {counts && counts.length === 0 && <div className="mt-6 border bg-white p-4 text-sm text-muted-foreground" data-testid="tech-inventory-empty">Nessun inventario da fare.</div>}
      {(counts || []).map((c) => (
        <section key={c.id} className="mt-6">
          <div className="micro-label mb-2">{c.number} · {c.warehouse_name}</div>
          {c.history?.filter((h) => h.action === "rejected").pop() && <p className="mb-2 border-l-4 border-red-600 bg-red-50 px-3 py-2 text-sm">Da ricontare: {c.history.filter((h) => h.action === "rejected").pop().note}</p>}
          <CountForm count={c} onDone={load} onReload={load} />
        </section>
      ))}
    </div>
  );
}
